"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var moment_1 = __importDefault(require("moment"));

function formatDatePartialFormat(date) {
  if (!date) {
    return date;
  }

  return "".concat(date.substring(4, 6), "/").concat(date.substring(0, 4));
}

exports.formatDatePartialFormat = formatDatePartialFormat;

function formatDateFullFormat(date) {
  if (!date) {
    return date;
  }

  return "".concat(date.substring(8, 10), "/").concat(date.substring(5, 7), "/").concat(date.substring(0, 4));
}

exports.formatDateFullFormat = formatDateFullFormat;

function formatDatePartialFormatPreviousYear(period) {
  if (!period) {
    return period;
  }

  return "".concat(period.substring(4, 6), "/").concat(parseInt(period.substring(0, 4), 10) - 1);
}

exports.formatDatePartialFormatPreviousYear = formatDatePartialFormatPreviousYear;

function formatDateToYYMMDDDD(date) {
  if (!date) {
    return date;
  }

  return "".concat(date.substring(6, 10), "-").concat(date.substring(3, 5), "-").concat(date.substring(0, 2));
}

exports.formatDateToYYMMDDDD = formatDateToYYMMDDDD;

function getMonthNumber(period) {
  return parseInt(period.substring(4, 6), 10);
}

exports.getMonthNumber = getMonthNumber;

function getYearNumber(period) {
  return parseInt(period.substring(0, 4), 10);
}

exports.getYearNumber = getYearNumber;

function dateToString(date) {
  return "".concat(date.getYear() + 1900, "-").concat(('0' + (date.getMonth() + 1)).substr(-2), "-").concat(('0' + date.getDate()).substr(-2));
}

exports.dateToString = dateToString;

function howLongSince(since, until) {
  if (!since || since > until) {
    return ' ';
  }

  var timeConstants = [1000, 60, 60, 24, 7, 4.3, 12];
  var detailString = [{
    singular: 'seg.',
    plural: 'seg.'
  }, {
    singular: 'min.',
    plural: 'min.'
  }, {
    singular: 'hora',
    plural: 'horas'
  }, {
    singular: 'día',
    plural: 'días'
  }, {
    singular: 'semana',
    plural: 'semanas'
  }, {
    singular: 'mes',
    plural: 'meses'
  }, {
    singular: 'año',
    plural: 'años'
  }];
  var value = new Date(until).getTime() - new Date(since).getTime();

  for (var i = 0; i < timeConstants.length; i += 1) {
    value = Math.abs(Math.trunc(value / timeConstants[i]));

    if (!timeConstants[i + 1] || value < timeConstants[i + 1]) {
      return "HACE ".concat(value, " ").concat(value > 1 ? detailString[i].plural : detailString[i].singular);
    }
  }

  return ' ';
}

exports.howLongSince = howLongSince;

exports.getCurrentDate = function (dateFormat) {
  return dateFormat ? moment_1.default().format(dateFormat) : moment_1.default();
};

exports.beforeToday = function (date) {
  return moment_1.default().isSameOrBefore(date);
};

var DATE_UTILS = {
  formatDatePartialFormat: formatDatePartialFormat,
  formatDateFullFormat: formatDateFullFormat,
  formatDatePartialFormatPreviousYear: formatDatePartialFormatPreviousYear,
  formatDateToYYMMDDDD: formatDateToYYMMDDDD,
  getMonthNumber: getMonthNumber,
  getYearNumber: getYearNumber,
  dateToString: dateToString,
  howLongSince: howLongSince,
  getCurrentDate: exports.getCurrentDate,
  beforeToday: exports.beforeToday
};
exports.default = DATE_UTILS;